import { createI18n } from 'vue-i18n';
import es from './locales/es';
import en from './locales/en';

const CLAVE = 'crmIdioma';

/**
 * El idioma vive en el NAVEGADOR, no en el servidor.
 *
 * No es una simplificacion: en la pantalla de inicio de sesion todavia no hay
 * sesion, asi que una preferencia guardada en la base no se podria leer ahi.
 * Y esa pantalla es justo donde Edwin quiere que se pueda elegir.
 *
 * Si mas adelante se quiere que el idioma siga a la persona entre dispositivos,
 * se guarda tambien en su usuario y al entrar se sobreescribe esto. Hasta
 * entonces, cada navegador recuerda su eleccion.
 */
export function idiomaGuardado() {
  try {
    const guardado = localStorage.getItem(CLAVE);
    if (guardado === 'es' || guardado === 'en') {
      return guardado;
    }
  } catch (e) {
    // Navegador con el almacenamiento bloqueado (ventana privada, por
    // ejemplo). No es un error: se cae al idioma por defecto.
  }

  // Se arranca en espanol porque es el idioma de todos los clientes de hoy.
  return 'es';
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: idiomaGuardado(),
  fallbackLocale: 'es',
  messages: { es, en },
});

/**
 * Pone un idioma SIN recordarlo.
 *
 * Lo usa la pagina publica de los formularios: ahi el idioma no lo elige quien
 * mira, lo manda el dueno del formulario. Si esto se guardara, a un cliente que
 * abre la landing de otro en su propio navegador se le cambiaria el idioma del
 * CRM sin haberlo pedido.
 */
export function aplicarIdiomaSinGuardar(codigo) {
  if (codigo !== 'es' && codigo !== 'en') {
    return;
  }

  i18n.global.locale.value = codigo;

  try {
    document.documentElement.setAttribute('lang', codigo);
  } catch (e) {
    /* nada */
  }
}

/** Cambia el idioma y lo recuerda. */
export function cambiarIdioma(codigo) {
  if (codigo !== 'es' && codigo !== 'en') {
    return;
  }

  i18n.global.locale.value = codigo;

  try {
    localStorage.setItem(CLAVE, codigo);
  } catch (e) {
    // Si no se puede guardar, el cambio vale para esta sesion y ya.
  }

  // El atributo lang del documento: lo usan el corrector ortografico del
  // navegador y los lectores de pantalla.
  try {
    document.documentElement.setAttribute('lang', codigo);
  } catch (e) {
    /* nada */
  }
}

export default i18n;
